module.exports = __webpack_public_path__ + "static/img/yundong.0ee7ebb0.png";